import { AxiosResponse } from 'axios';
import { Tenant } from './interfaces';
import { IGetResourceResponse } from '@api/interfaces';
import apiClient from '@api/axios';

export const getTenant = async (): Promise<Tenant> => {
  const response: AxiosResponse<IGetResourceResponse<Tenant>> =
    await apiClient.get(`/tenant`);

  return response.data.data;
};
